// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxLoggerLevel } from 'ngx-logger';
export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },

  // api:'https://vcontroltfcm.mx/apirest/api/',
  // api:'https://mbqdatacloud.com/api_volumetricosmbq/api/',
  // api:'https://mbqdatacloud.com/api_volumetricros_linker/api/',
  // api:'http://10.196.92.35/apirest/api/',
  // api:'http://localhost:3000/api/',

  api:'https://terniumpesqueria.scvplatform.com/api/',


  // api:'https://.mbqdatacloud.com/api_demo/api/',
  idleTimeInMinutes: 10,
  logLevel: NgxLoggerLevel.OFF,
  serverLogLevel: NgxLoggerLevel.ERROR
  // api:'http://3.130.135.31:3000/api/'

};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
